import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import type { ChatDetailLocationState } from '../page-chat-detail';

export const useNavigateToChatroom = () => {
  const navigate = useNavigate();

  return useCallback(
    async (chatroomId: string, state?: ChatDetailLocationState) => {
      await navigate(routes.chat.chatroom(chatroomId), {
        replace: true,
        state,
      });
    },
    [navigate],
  );
};
